import * as React from "react"

import { RowContentCell, CellType } from "@tenforce/toolbox-table-react"
import { ActionAnchor, ActionType } from "@tenforce/toolbox-button-push-react"

interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
    label: string
    symbol: string
    url: string
}

export const ActionRow = ({
    label,
    symbol,
    url,
    ...attrs
}: Props): JSX.Element => (
    <RowContentCell cellProps={{ type: CellType.action }}>
        <ActionAnchor
            href={url}
            actionType={ActionType.block}
            extraClasses="text-black tw-px-2"
            {...attrs}
        >
            <div className="tw-truncate">
                {symbol}&nbsp;{label}
            </div>
        </ActionAnchor>
    </RowContentCell>
)

export default ActionRow
